import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const colorList2 = [
  "#2ca25f",
  "#8856a7",
  "#e34a33",
  "#1c9099",
  "#636363",
  "#c51b8a",
  "#756bb1",
  "#31a354",
  themeStyle.primaryColor,
  "#e6550d",
];

function AddFees() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [feesStructure, setFeesStructure] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [feesName, setFeesName] = useState("");
  const [classList, setClassList] = useState([]);
  const [open2, setOpen2] = useState(false);
  const [selectedFees, setSelectedFees] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("GENERAL");
  const [notes, setNotes] = useState("");

  const [random, setRandom] = useState("");
  var colorIndex = 0;

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [toggleDrawer2, setToggleDrawer2] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [feesStructure2, setFeesStructure2] = useState("{}");
  const [feesItemIndex, setFeesItemIndex] = useState(9999);

  function addFeesExpense() {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure["New expense"] = {
      cost: "10000",
      csi: false,
      general: false,
      staff: false,
    };
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function deleteFeesExpense(index) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    delete tempFeesStructure[Object.keys(tempFeesStructure)[index]];
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function editFeesExpense(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    var tempFeesCost = tempFeesStructure[Object.keys(tempFeesStructure)[index]];
    delete tempFeesStructure[Object.keys(tempFeesStructure)[index]];
    tempFeesStructure[value] = tempFeesCost;
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function editFeesCost(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[Object.keys(tempFeesStructure)[index]]["cost"] = value;
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function editFeesCategory(index, value, category) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[Object.keys(tempFeesStructure)[index]][category] = value;
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function getTotalFees() {
    var total = 0;
    var tempFeesStructure = JSON.parse(feesStructure2);
    for (var i = 0; i < Object.keys(tempFeesStructure).length; i++) {
      if (!tempFeesStructure[Object.keys(tempFeesStructure)[i]]["general"]) {
        total += parseInt(
          tempFeesStructure[Object.keys(tempFeesStructure)[i]]["cost"]
        );
      }
    }
    return total;
  }

  function getTotalFeesCSI() {
    var total = 0;
    var tempFeesStructure = JSON.parse(feesStructure2);
    for (var i = 0; i < Object.keys(tempFeesStructure).length; i++) {
      if (!tempFeesStructure[Object.keys(tempFeesStructure)[i]]["csi"]) {
        total += parseInt(
          tempFeesStructure[Object.keys(tempFeesStructure)[i]]["cost"]
        );
      }
    }
    return total;
  }

  function getTotalFeesSTAFF() {
    var total = 0;
    var tempFeesStructure = JSON.parse(feesStructure2);
    for (var i = 0; i < Object.keys(tempFeesStructure).length; i++) {
      if (!tempFeesStructure[Object.keys(tempFeesStructure)[i]]["staff"]) {
        total += parseInt(
          tempFeesStructure[Object.keys(tempFeesStructure)[i]]["cost"]
        );
      }
    }
    return total;
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  function addFeesStructure() {
    if (selectedClasses.length == 0) {
      createAlert("ERROR", "Error", "Please select at least one class.");
      return;
    }

    if (feesName == "") {
      createAlert("ERROR", "Error", "Please enter the fees name.");
      return;
    }

    if (selectedDate == null) {
      createAlert("ERROR", "Error", "Please select the last payment date.");
      return;
    }

    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;

    body["fees_bracket"] = {
      id: makeid(10),
      fees_name: feesName,
      classes: selectedClasses,
      last_payment_date: moment(selectedDate).format("DD-MM-YYYY"),
      date: moment().format("DD-MM-YYYY"),
      fees_structure: feesStructure2,
      category: selectedCategory,
      notes: notes,
    };

    axios
      .post(API_URL + "/add_fees_bracket", body, config)
      .then((res) => {
        createAlert("SUCCESS", "Success", "Fees structure added.");
        setIsSubmitting(false);
        setFeesName("");
        setSelectedDate(new Date());
        setSelectedClasses([]);
        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
        setIsSubmitting(false);
      });
  }

  function deleteItem() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["id"] = selectedFees;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/delete_fees_bracket", body, config)
      .then((res) => {
        setOpen2(false);
        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_fees_structure", body, config)
      .then((res) => {
        setFeesStructure(res.data);
        axios.post(API_URL + "/get_class_list", body, config).then((res) => {
          setClassList(res.data);
          setIsLoading(false);
        });
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    if (feesStructure.length == 0) {
      return (
        <div
          style={{
            marginTop: "200px",
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Fab
              size="large"
              style={{
                border: "3px solid #aaa",
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
              aria-label="add"
            >
              <PriorityHighIcon
                style={{
                  color: "grey",
                }}
              />
            </Fab>
            <br />
            <h4 style={{ color: "grey" }}>
              No Fess bracket entries have been recorded.
            </h4>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "100vw", fontSize: "18px" }}>
          <h2>Previous Fees Brackets List</h2>
          <Grid
            container
            style={{
              paddingBottom: "5px",
              marginBottom: "5px",
              borderBottom: "1px solid #aaa",
            }}
          >
            <Grid item md={1}>
              Sr.
            </Grid>
            <Grid item md={2}>
              Fees Name
            </Grid>
            <Grid item md={3}>
              Classes
            </Grid>

            <Grid item md={2}>
              Added Date
            </Grid>
            <Grid item md={2}>
              Last Date
            </Grid>
            <Grid item md={1}>
              Category
            </Grid>
            <Grid
              item
              md={1}
              style={{ display: "flex", justifyContent: "center" }}
            >
              Delete
            </Grid>
          </Grid>
          {feesStructure.map((item, index) => (
            <Grid container style={{ marginTop: "15px" }}>
              <Grid item md={1}>
                {index + 1}
              </Grid>
              <Grid item md={2}>
                {item.fees_name}
              </Grid>

              <Grid item md={3}>
                {item.classes.toString()}
              </Grid>
              <Grid item md={2}>
                {item.date}
              </Grid>
              <Grid item md={2}>
                {item.last_payment_date}
              </Grid>
              <Grid item md={1}>
                {item.category}
              </Grid>
              <Grid
                item
                md={1}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <ButtonBase
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    backgroundColor: "#ff3333",
                    padding: "5px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    setSelectedFees(item.id);
                    setOpen2(true);
                  }}
                >
                  <DeleteIcon style={{ color: "white", fontSize: "18px" }} />
                </ButtonBase>
              </Grid>
            </Grid>
          ))}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_billing) {
        return (
          <Fragment>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3>Delete this item?</h3>
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>

                    <span>
                      This action cannot be reversed. It will be deleted
                      forever.
                    </span>
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={() => deleteItem()}
                        style={{ height: "30px" }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                      <Button
                        style={{ height: "30px", marginLeft: "10px" }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <Drawer
              anchor={"right"}
              open={toggleDrawer2}
              onClose={() => setToggleDrawer2(false)}
            >
              <div
                style={{
                  padding: "15px",
                  width: "60vw",
                  marginTop: "23px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    marginTop: "45px",
                    color: themeStyle.primaryColor,
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Fees Breakdown
                </div>
                <br />
                {Object.keys(JSON.parse(feesStructure2)).length == 0 ? (
                  <div
                    style={{
                      color: colorList2[colorIndex],
                      fontSize: "20px",
                    }}
                  >
                    Press The " + " button to add Expenses.
                  </div>
                ) : (
                  ""
                )}
                <br />
                {Object.keys(JSON.parse(feesStructure2)).map((fees, index) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      height: "50px",
                      marginBottom: "10px",
                      width: "100%",
                      padding: "15px",
                    }}
                  >
                    {feesItemIndex == index ? (
                      <TextField
                        style={{ width: "30%" }}
                        fullWidth
                        size="small"
                        placeholder="Expense"
                        variant="outlined"
                        value={fees}
                        onChange={(e) => editFeesExpense(index, e.target.value)}
                      />
                    ) : (
                      <div style={{ width: "30%" }}>
                        <h3 style={{ marginTop: "12px" }}>{fees}</h3>
                      </div>
                    )}
                    {feesItemIndex == index ? (
                      <TextField
                        style={{
                          marginLeft: "15px",
                          width: "20%",
                        }}
                        size="small"
                        placeholder="Cost"
                        variant="outlined"
                        type="number"
                        value={JSON.parse(feesStructure2)[fees]["cost"]}
                        onChange={(e) => editFeesCost(index, e.target.value)}
                      />
                    ) : (
                      <div style={{ width: "20%" }}>
                        <h3
                          style={{
                            marginLeft: "20px",
                            marginTop: "12px",
                            display: "flex",
                          }}
                        >
                          &#8377;
                          {" " + JSON.parse(feesStructure2)[fees]["cost"]}
                        </h3>
                      </div>
                    )}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        labelStyle={{ color: themeStyle.primaryColor }}
                        iconStyle={{ fill: "white" }}
                        inputStyle={{ color: themeStyle.primaryColor }}
                        style={{
                          marginBottom: "2px",
                          color: themeStyle.primaryColor,
                        }}
                        checked={JSON.parse(feesStructure2)[fees]["general"]}
                        onChange={(e) => {
                          editFeesCategory(index, e.target.checked, "general");
                        }}
                        value={1}
                        color={"primary"}
                      />
                      <span
                        style={{
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Exclude GENERAL
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        labelStyle={{ color: themeStyle.primaryColor }}
                        iconStyle={{ fill: "white" }}
                        inputStyle={{ color: themeStyle.primaryColor }}
                        style={{
                          marginBottom: "2px",
                          color: themeStyle.primaryColor,
                        }}
                        checked={JSON.parse(feesStructure2)[fees]["csi"]}
                        onChange={(e) => {
                          editFeesCategory(index, e.target.checked, "csi");
                        }}
                        value={1}
                        color={"primary"}
                      />
                      <span
                        style={{
                          color: themeStyle.primaryColor,

                          fontSize: "14px",
                        }}
                      >
                        Exclude CSI
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        labelStyle={{ color: themeStyle.primaryColor }}
                        iconStyle={{ fill: "white" }}
                        inputStyle={{ color: themeStyle.primaryColor }}
                        style={{
                          marginBottom: "2px",
                          color: themeStyle.primaryColor,
                        }}
                        checked={JSON.parse(feesStructure2)[fees]["staff"]}
                        onChange={(e) => {
                          editFeesCategory(index, e.target.checked, "staff");
                        }}
                        value={1}
                        color={"primary"}
                      />
                      <span
                        style={{
                          color: themeStyle.primaryColor,
                          fontSize: "14px",
                        }}
                      >
                        Exclude STAFF CHILDREN
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "30px",
                        justifyContent: "center",
                      }}
                    >
                      {feesItemIndex == index ? (
                        <Button
                          onClick={() => setFeesItemIndex(9999)}
                          style={{ borderRadius: "20px" }}
                        >
                          <SaveIcon />
                        </Button>
                      ) : (
                        <Button
                          onClick={() => setFeesItemIndex(index)}
                          style={{ borderRadius: "20px" }}
                        >
                          <EditIcon />
                        </Button>
                      )}

                      <Button
                        onClick={() => deleteFeesExpense(index)}
                        style={{ borderRadius: "20px" }}
                      >
                        <DeleteIcon style={{ color: "#ff3333" }} />
                      </Button>
                    </div>
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <Fab
                    size="small"
                    style={{
                      boxShadow: "none",
                      backgroundColor: themeStyle.primaryColor,
                    }}
                    onClick={() => addFeesExpense()}
                    aria-label="add"
                  >
                    <AddIcon
                      style={{
                        color: "white",
                      }}
                    />
                  </Fab>
                </div>
                <br />
                {Object.keys(feesStructure2).length !== 0 ? (
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderTop: "1px solid black",
                        marginTop: "10px",
                        marginBottom: "5px",
                      }}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{}}>Total For General Category</div>{" "}
                      <div style={{}}> &#8377;{getTotalFees()}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <br />
                {Object.keys(feesStructure2).length !== 0 ? (
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderTop: "1px solid black",
                        marginTop: "10px",
                        marginBottom: "5px",
                      }}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{}}>Total for CSI category</div>{" "}
                      <div style={{}}> &#8377;{getTotalFeesCSI()}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <br />
                {Object.keys(feesStructure2).length !== 0 ? (
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderTop: "1px solid black",
                        marginTop: "10px",
                        marginBottom: "5px",
                      }}
                    ></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{}}>Total for Staff Children</div>{" "}
                      <div style={{}}> &#8377;{getTotalFeesSTAFF()}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <br />
                <br />
                Select for which category you want to add fees
                <Select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  style={{
                    width: "100%",
                    marginTop: "5px",
                  }}
                >
                  <MenuItem value="GENERAL">General Fees</MenuItem>
                  <MenuItem value="REGISTRATION">Registration Fees</MenuItem>
                  <MenuItem value="OTHERS">Others</MenuItem>
                </Select>
                <br />
                <TextField
                  style={{ marginTop: "2px" }}
                  multiline
                  rows={5}
                  fullWidth
                  variant="outlined"
                  placeholder="Extra Notes / Remarks"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
                <br></br>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    height: "35px",
                  }}
                >
                  <Button
                    onClick={() => {
                      setToggleDrawer2(false);
                      setToggleDrawer(true);
                    }}
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: themeStyle.primaryColor,
                      boxShadow: "none",
                    }}
                  >
                    <h4>Continue</h4>
                  </Button>
                </Box>
              </div>
            </Drawer>
            <Drawer
              anchor={"right"}
              open={toggleDrawer}
              onClose={() => setToggleDrawer(false)}
            >
              {isSubmitting ? (
                <div
                  style={{
                    marginTop: "60px",
                    padding: "20px",
                    width: "20vw",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                  <h3>Uploading in progress...</h3>
                </div>
              ) : (
                <div
                  style={{ padding: "15px", marginTop: "23px", width: "20vw" }}
                >
                  <div
                    style={{
                      marginTop: "45px",
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Last Payment Date
                  </div>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat="dd-MM-yyyy"
                      value={selectedDate}
                      sx={{
                        height: "40px",
                        width: "100%",
                        marginTop: "5px",
                        marginBottom: "20px",
                      }}
                      onChange={handleDateChange}
                      fullWidth
                      renderInput={(params) => (
                        <TextField
                          style={{
                            width: "100%",
                            marginTop: "2px",
                            marginBottom: "5px",
                            height: "40px",
                          }}
                          size="small"
                          fullWidth
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <br></br>
                  <span
                    style={{
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Name
                  </span>
                  <TextField
                    style={{ marginTop: "2px", marginBottom: "15px" }}
                    value={feesName}
                    fullWidth
                    size="small"
                    onChange={(e) => setFeesName(e.target.value)}
                    placeholder={"Fees Name"}
                    variant="outlined"
                  />
                  {Object.keys(classList).map((classs, index) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        disableRipple={true}
                        labelStyle={{ color: themeStyle.primaryColor }}
                        iconStyle={{ fill: "white" }}
                        checked={selectedClasses.includes(classs)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedClasses([...selectedClasses, classs]);
                          } else {
                            setSelectedClasses(
                              selectedClasses.filter((item) => item !== classs)
                            );
                          }
                        }}
                        value={1}
                        style={{
                          transform: "scale(1.5)",
                          color: themeStyle.primaryColor,
                        }}
                      />
                      <span style={{ textAlign: "center", marginTop: "0px" }}>
                        {classs}
                      </span>
                    </div>
                  ))}
                  <br></br>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      height: "35px",
                    }}
                  >
                    <Button
                      onClick={() => addFeesStructure()}
                      fullWidth
                      variant="contained"
                      style={{
                        backgroundColor: themeStyle.primaryColor,
                        boxShadow: "none",
                      }}
                    >
                      <h4>Add Fees Structure</h4>
                    </Button>
                  </Box>
                </div>
              )}
            </Drawer>
            <div
              style={{
                height: "50px",
                width: "225px",
                padding: "5px 10px",
                borderRadius: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "none",
                backgroundColor: themeStyle.primaryColor,
                position: "fixed",
                bottom: 30,
                right: 30,
                cursor: "pointer",
              }}
              onClick={() => setToggleDrawer2(true)}
              aria-label="add"
            >
              <AddBoxIcon
                style={{
                  color: "white",
                  marginRight: "15px",
                  fontSize: "30px",
                }}
              />
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                Add New Fees
              </div>
            </div>
            <Sidebar />
            <div
              style={{
                margin: "38px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default AddFees;
